import type { CheckoutStatus, Lang } from './lib/params'

interface Copy {
  title: string
  body: string
}

const COPY: Record<Lang, Record<CheckoutStatus, Copy>> = {
  da: {
    success: {
      title: 'Kortet er registreret',
      body: 'Du kan lukke dette vindue.',
    },
    cancel: {
      title: 'Du annullerede',
      body: 'Du kan lukke dette vindue.',
    },
    unknown: {
      title: 'Vi kunne ikke bekræfte status',
      body: 'Kontakt support hvis du er i tvivl om din kortregistrering.',
    },
  },
  en: {
    success: {
      title: 'Your card is registered',
      body: 'You can close this window.',
    },
    cancel: {
      title: 'You cancelled',
      body: 'You can close this window.',
    },
    unknown: {
      title: 'We could not confirm the status',
      body: 'Contact support if you are unsure about your card registration.',
    },
  },
}

export function copyFor(lang: Lang, status: CheckoutStatus): Copy {
  return COPY[lang][status]
}

export function countdownLabel(lang: Lang, seconds: number): string {
  return lang === 'da' ? `Vinduet lukker om ${seconds} sek` : `Closing in ${seconds}s`
}
